import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { useCallback, useEffect, useState, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import { routePush, buildGtmBannerEventData, useCookies } from '@magalu/mixer-utils';
import { useClient, AdsBrandsQuery, useAdsEvents } from '@magalu/mixer-graphql';
import { parseBrand, getCustomerId } from '../AdsBrands.utils';
import { usePublisher } from '@magalu/mixer-publisher';
export var useAdsBrands = function useAdsBrands(_ref) {
  var _structure$route, _brand$content, _brand$content2, _structure$route2;
  var _ref$brands = _ref.brands,
    brands = _ref$brands === void 0 ? [] : _ref$brands,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$static = _ref["static"],
    staticProps = _ref$static === void 0 ? {} : _ref$static,
    _ref$structure = _ref.structure,
    structure = _ref$structure === void 0 ? {} : _ref$structure;
  var adsPath = staticProps.adsPath,
    channel = staticProps.channel,
    staticCustomerId = staticProps.customerId,
    screenName = staticProps.screenName,
    size = staticProps.size;
  var customerId = getCustomerId(staticCustomerId);
  var _useCookies = useCookies(),
    location = _useCookies.location;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    brand = _useState2[0],
    setBrand = _useState2[1];
  var adsPlacement = useMemo(function () {
    return "".concat(adsPath, "/").concat(brand == null ? void 0 : brand.slot);
  }, [adsPath, brand]);
  var adsEventsData = useMemo(function () {
    return {
      adsPath: adsPlacement,
      customerId: customerId,
      data: data,
      structure: structure
    };
  }, [adsPlacement, customerId, data, structure]);
  var eventData = {
    ad_type: 'sponsored_brands',
    customer_id: customerId,
    display: 'gallery',
    filters: structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.filters,
    list: brand == null ? void 0 : (_brand$content = brand.content) == null ? void 0 : _brand$content.headline,
    listPosition: 1,
    origin: "ads",
    pageName: structure == null ? void 0 : structure.name,
    showcase: {
      placeId: 'sponredbrandshowcase',
      title: brand == null ? void 0 : (_brand$content2 = brand.content) == null ? void 0 : _brand$content2.headline,
      type: 'carousel'
    },
    term: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term,
    type: 'marca-patrocinada'
  };
  var client = useClient();
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var _useAdsEvents = useAdsEvents(adsEventsData),
    sendAdsClickEvents = _useAdsEvents.sendAdsClickEvents,
    sendAdsImpressionEvents = _useAdsEvents.sendAdsImpressionEvents;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var inViewConfig = useMemo(function () {
    return {
      threshold: 0.5,
      triggerOnce: false
    };
  }, []);
  var _useInView = useInView(inViewConfig),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var isVideo = useMemo(function () {
    var _brand$content$imageU, _brand$content3, _brand$content3$image;
    return (_brand$content$imageU = brand == null ? void 0 : (_brand$content3 = brand.content) == null ? void 0 : (_brand$content3$image = _brand$content3.imageUrl) == null ? void 0 : _brand$content3$image.includes('.m3u8')) !== null && _brand$content$imageU !== void 0 ? _brand$content$imageU : false;
  }, [brand]);
  var displayMode = useMemo(function () {
    if (isVideo) {
      return 'sponsored_brands-video';
    }
    return (brand == null ? void 0 : brand.template) === 'collection' ? 'sponsored_brands-logo' : 'sponsored_brands-imagem';
  }, [isVideo, brand]);
  var metadata = useMemo(function () {
    return {
      channelCode: channel,
      customerId: customerId,
      isLoyalty: false
    };
  }, [channel, customerId]);
  var promotionEventData = useMemo(function () {
    var _brand$content4, _brand$content5;
    if (!brand) return null;
    var brandBanner = {
      campaignId: brand == null ? void 0 : brand.campaignId,
      imageUrl: brand == null ? void 0 : (_brand$content4 = brand.content) == null ? void 0 : _brand$content4.imageUrl,
      redirectUrl: brand == null ? void 0 : (_brand$content5 = brand.content) == null ? void 0 : _brand$content5.redirectUrl,
      slot: brand == null ? void 0 : brand.slot,
      trackId: brand == null ? void 0 : brand.trackId
    };
    var eventDetails = {
      index: 0,
      position: 1,
      size: size || 'medium',
      slot: brandBanner == null ? void 0 : brandBanner.slot,
      vendorId: brand == null ? void 0 : brand.sellerId
    };
    return buildGtmBannerEventData(brandBanner, false, screenName, structure, eventDetails);
  }, [brand, size, screenName, structure, buildGtmBannerEventData]);
  var brandRedirectUrl = useMemo(function () {
    var _brand$content6;
    if (!(brand == null ? void 0 : (_brand$content6 = brand.content) == null ? void 0 : _brand$content6.redirectUrl)) return null;
    try {
      var _brand$content7;
      var url = new URL(brand == null ? void 0 : (_brand$content7 = brand.content) == null ? void 0 : _brand$content7.redirectUrl);
      url.searchParams.append('track_id', brand == null ? void 0 : brand.trackId);
      url.searchParams.append('internal_ad', 'true');
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [brand]);
  var handleBrandClick = useCallback(function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(e) {
      var eventName;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            eventName = 'promotion:brand:click';
            publish(eventName, promotionEventData);
            _context.next = 5;
            return sendAdsClickEvents([{
              adType: 'SPONSORED_BRAND',
              trackId: brand == null ? void 0 : brand.trackId
            }]);
          case 5:
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
          case 10:
            _context.prev = 10;
            if ((e == null ? void 0 : e.button) === 0) {
              routePush({
                path: brandRedirectUrl,
                spa: false
              });
            }
            return _context.finish(10);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7, 10, 13]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [brand, publish, sendAdsClickEvents, promotionEventData]);
  var handleBrandImpression = useCallback(function () {
    var eventName = 'promotion:brand:view';
    publish(eventName, promotionEventData);
    sendAdsImpressionEvents([{
      adType: 'SPONSORED_BRAND',
      trackId: brand == null ? void 0 : brand.trackId
    }]);
  }, [brand, publish, sendAdsImpressionEvents, promotionEventData]);
  var fetchAdsBrands = useCallback(_asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    var _responseData$adsBran, _yield$client$query, responseData, parsedBrand;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          if (!(!(brands == null ? void 0 : brands.length) || !metadata)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          setLoading(true);
          _context2.next = 6;
          return client.query({
            fetchPolicy: 'no-cache',
            query: AdsBrandsQuery,
            variables: {
              input: {
                brands: brands,
                metadata: metadata,
                zipcode: (location == null ? void 0 : location.zipCode) || ''
              }
            }
          });
        case 6:
          _yield$client$query = _context2.sent;
          responseData = _yield$client$query.data;
          parsedBrand = parseBrand((responseData == null ? void 0 : (_responseData$adsBran = responseData.adsBrands) == null ? void 0 : _responseData$adsBran.length) ? responseData == null ? void 0 : responseData.adsBrands[0] : null, structure);
          setBrand(parsedBrand);
          _context2.next = 15;
          break;
        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
        case 15:
          _context2.prev = 15;
          setLoading(false);
          return _context2.finish(15);
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 12, 15, 18]]);
  })), [brands, metadata]);
  var handleProductClick = function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(e, product) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            publish('productlist:selectItem:click', _extends({}, eventData, product, {
              displayMode: displayMode
            }));
            _context3.next = 4;
            return sendAdsClickEvents([{
              additionalAttribution: {
                id: product == null ? void 0 : product.id,
                type: 'product'
              },
              adType: 'SPONSORED_BRAND',
              position: (product == null ? void 0 : product.position) - 1,
              trackId: brand == null ? void 0 : brand.trackId
            }]);
          case 4:
            _context3.next = 9;
            break;
          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0);
          case 9:
            _context3.prev = 9;
            if ((e == null ? void 0 : e.button) === 0) {
              routePush({
                path: product.url,
                spa: false
              });
            }
            return _context3.finish(9);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 6, 9, 12]]);
    }));
    return function handleProductClick(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleProductView = useCallback(function (product) {
    if (product) {
      publish('product:viewItemList', _extends({}, eventData, product, {
        displayMode: displayMode
      }));
    }
  }, [publish, displayMode, eventData]);
  useEffect(function () {
    var fetchData = function () {
      var _ref5 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return fetchAdsBrands();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function fetchData() {
        return _ref5.apply(this, arguments);
      };
    }();
    fetchData();
  }, [fetchAdsBrands]);
  return {
    adsPath: adsPlacement,
    brand: brand,
    handleBrandClick: handleBrandClick,
    handleBrandImpression: handleBrandImpression,
    handleProductClick: handleProductClick,
    handleProductView: handleProductView,
    inView: inView,
    isVideo: isVideo,
    loading: loading,
    ref: ref
  };
};